/**
 * Inserción de una variable en el cuerpo de la plantilla. Separada del
 * componente para poder probarla sin `TestBed`, mismo criterio que
 * `flujo/flujo-form.util.ts`.
 */

export interface IRangoCursor {
    desde: number;
    hasta: number;
}

export interface IResultadoInsercion {
    texto: string;
    /** Dónde queda el cursor: justo después de lo insertado, para poder seguir escribiendo. */
    cursor: number;
}

/**
 * Mete `variable` en `texto` reemplazando `rango`. `rango` en `null` la manda al
 * final. Se recorta contra el largo real: el cursor recordado pudo quedar más
 * allá del final si el texto se acortó.
 */
export const insertarVariableEnTexto = (
    texto: string,
    variable: string,
    rango: IRangoCursor | null,
): IResultadoInsercion => {
    const base = String(texto || '');
    const fin = base.length;
    const pedido = rango ?? { desde: fin, hasta: fin };

    const desde = Math.min(Math.max(pedido.desde, 0), fin);
    const hasta = Math.min(Math.max(pedido.hasta, desde), fin);

    return {
        texto: `${base.slice(0, desde)}${variable}${base.slice(hasta)}`,
        cursor: desde + variable.length,
    };
};
